<template>
  <!-- 行为监控 -->
  <div class="behavior">

    <el-form class="bginput" style="margin-bottom: 0.8rem;" label-width="8rem">
      <el-form-item label="行为监控数据">
        <el-row :gutter="0">
          <el-col :span="6">
            <el-select v-model="set.getType" placeholder="请选择">
              <el-option label="手动录入" :value="0"></el-option>
              <el-option label="后台获取" :value="1"></el-option>
            </el-select>
          </el-col>

          <!-- <el-col :span="2">
            <el-button type="primary">添加数据</el-button>
          </el-col> -->
        </el-row>
      </el-form-item>
    </el-form>


    <table class="mytable" style="width:80%">
      <thead>
        <tr>
          <th style="width: 15rem;">提示时间</th>
          <th>事件类型</th>
          <th>发生区域</th>
          <th>事件主体</th>
          <th>
            <i @click="add" style="font-size: 1.2rem;font-weight: 600;cursor:pointer;position: relative;top: 0.1rem;color: #00ffff;" class="el-icon-circle-plus-outline"></i>
          </th>
        </tr>
      </thead>

      <tbody>

        <tr v-for="(item,i) in formData" :key='i'>
          <td>
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" v-model="item.eventTime" type="datetime" placeholder="选择日期时间"> </el-date-picker>
          </td>
          <td>
            <el-input v-model="item.eventCase" placeholder="请输入"></el-input>
          </td>
          <td>
            <el-input v-model="item.eventArea" placeholder="请输入"></el-input>
          </td>
          <td>
            <el-input v-model="item.eventBody" placeholder="请输入"></el-input>
          </td>
          <td style="width: 6rem;text-align: center;">
            <i @click="del(item,i)" class="el-icon-remove-outline" style="font-size: 1.2rem;line-height: 1.8rem;color: #f00;font-weight: 600;cursor: pointer;"></i>
          </td>
        </tr>

      </tbody>
    </table>
    <p v-if="!formData.length" style="text-align: center;margin-top: 5rem;">暂无数据<p>

    <div style="margin-top: 2rem;">
      <el-button @click="save()" size="small" type="primary">保存设置</el-button>
    </div>

  </div>
</template>

<script>
import api from '@/apis/safety/behavior'
export default {
  data() {
    return {
      value1: '',
      set: {
        getType: 0,
      },
      formData: [
        // {
        //   eventArea:"",//事件区域
        //   eventBody:"",//事件主体
        //   eventCase:"",//事件类型
        //   eventTime:"",//提示事件
        // },
      ],
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    add() {
      this.formData.push({
        eventArea: '', //事件区域
        eventBody: '', //事件主体
        eventCase: '', //事件类型
        eventTime: '', //提示事件
      })
    },
    getlist() {
      api
        .list({
          params: {
            limit: 100,
            page: 1,
          },
        })
        .then((res) => {
          if (res.code === 10000) {
            if (res.data.list.length) {
              this.formData = res.data.list
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    save() {
      api.save(this.formData).then((res) => {
        if (res.code === 10000) {
          this.$message.success(res.message)
          this.getlist()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    del(item, i) {
      this.$confirm(`确定删除数据？`).then(() => {
        if (item.id) {
          for (const iterator of this.formData) {
            if (iterator.id === undefined) {
              return this.$message.warning(
                '还有未保存的数据,请先保存后再删除！'
              )
            }
          }

          api.del([item.id]).then((res) => {
            if (res.code === 10000) {
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
            this.getlist()
          })
        } else {
          this.formData.splice(i, 1)
        }
      })
    },
  },
}
</script>

<style lang="less">
.behavior { padding-top: 10px;
  .el-form-item {
    margin-bottom: 0;
  }
}
</style>